
interface StatsCardProps {
  title: string;
  value: string | number;
  icon: string;
  change?: string;
  changeType?: 'increase' | 'decrease' | 'neutral';
}

export default function StatsCard({ title, value, icon, change, changeType = 'neutral' }: StatsCardProps) {
  const getChangeColor = () => {
    switch (changeType) {
      case 'increase':
        return 'text-green-600';
      case 'decrease':
        return 'text-red-600';
      default:
        return 'text-gray-500';
    }
  };

  const getChangeIcon = () => {
    switch (changeType) {
      case 'increase':
        return 'ri-arrow-up-line';
      case 'decrease':
        return 'ri-arrow-down-line';
      default:
        return 'ri-subtract-line';
    }
  };

  const getChangeBg = () => {
    switch (changeType) {
      case 'increase':
        return 'bg-green-50 border-green-200';
      case 'decrease':
        return 'bg-red-50 border-red-200';
      default:
        return 'bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-200 hover:border-orange-200 hover:shadow-md transition-all duration-200">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-2">{title}</p>
          <p className="text-3xl font-bold text-black mb-3">{value}</p>
          {change && (
            <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm border ${getChangeBg()}`}>
              <div className="w-4 h-4 flex items-center justify-center mr-1">
                <i className={`${getChangeIcon()} text-xs ${getChangeColor()}`}></i>
              </div>
              <span className={`font-medium ${getChangeColor()}`}>{change}</span>
            </div>
          )}
        </div>
        <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center ml-4">
          <i className={`${icon} text-2xl text-orange-600`}></i>
        </div>
      </div>
    </div>
  );
}
